import globalState from "../state";

const defaultErrMsgPath = "i18n.errors.general";

/**
 * @typedef {Object} ErrMsg
 * @property {string} devReason - The error message to display in dev mode
 * @property {string} message - server error message
 * @property {string} errMsg - user facing error message
 */


/**
 * Get the error message to display to the user
 * @param {Object} error - The error object
 * @param {string} message - The error message to display
 * @return {ErrMsg} - The error message object
 */
export default function getErrMsg({ error = {}, message }) {
    let errMsgPath = defaultErrMsgPath;

    if (error.message) {
        errMsgPath = error.message.includes("i18n") ?
            error.message :
            `i18n.errors.${error.message}`; // error.message could be path, eg "productKey.invalid-key"
    }

    const errMsg = globalState.getAndSub(errMsgPath, [ "urls.troubleLoggingIn" ]) || globalState[defaultErrMsgPath];

    return {
        /* program:dev */
        devReason : error.devReason,
        message,
        /* /program:dev */
        errMsg
    };
}
